<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container">
    <div class="form-group row" alAnchor="agent.name">
      <label for="title" class="label col-sm-3 col-form-label">
        {{ "input.name.label" | translate }}
        <nb-icon
          icon="question-mark-circle-outline"
          nbPopover="{{ 'popovers.inputName' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <div class="col-sm-9">
        <input
          type="text"
          nbInput
          fullWidth
          id="name"
          placeholder="{{ 'input.name.placeholder' | translate }}"
          formControlName="name"
          [status]="showInputError('name') ? 'danger' : 'basic'"
        />
      </div>
    </div>

    <div class="form-group row">
      <label for="title" class="label col-sm-3 col-form-label">
        {{ "input.description.label" | translate }}
        <nb-icon
          icon="question-mark-circle-outline"
          nbPopover="{{ 'popovers.inputDescription' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <div class="col-sm-9">
        <textarea
          type="text"
          nbInput
          fullWidth
          id="description"
          placeholder="{{ 'input.description.placeholder' | translate }}"
          formControlName="description"
          [status]="showInputError('description') ? 'danger' : 'basic'"
        ></textarea>
      </div>
    </div>

    <div class="form-group row">
      <label for="title" class="label col-sm-3 col-form-label">
        {{ "input.displayName.label" | translate }}

        <nb-icon
          icon="question-mark-circle-outline"
          nbPopover="{{ 'popovers.inputDisplayName' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon
      ></label>
      <div class="col-sm-9">
        <input
          type="text"
          nbInput
          fullWidth
          id="visual_name"
          placeholder="{{ 'input.displayName.placeholder' | translate }}"
          formControlName="visual_name"
          [status]="showInputError('visual_name') ? 'danger' : 'basic'"
        />
      </div>
    </div>

    <div class="form-group row" alAnchor="agent.welcome-message">
      <label for="title" class="label col-sm-3 col-form-label">
        {{ "input.welcomeMessage.label" | translate }}
        <nb-icon
          icon="question-mark-circle-outline"
          nbPopover="{{ 'popovers.inputWelcomeMessage' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <div class="col-sm-9">
        <textarea
          type="text"
          nbInput
          fullWidth
          id="welcome_message"
          placeholder=" {{ 'input.welcomeMessage.placeholder' | translate }}"
          formControlName="welcome_message"
          [status]="showInputError('welcome_message') ? 'danger' : 'basic'"
        ></textarea>
      </div>
    </div>

    <div class="form-group row">
      <label for="title" class="label col-sm-3 col-form-label">
        {{ "input.tutorTemplate.label" | translate }}
        <nb-icon
          icon="question-mark-circle-outline"
          nbPopover="{{ 'popovers.inputTutorTemplate' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <div class="col-sm-9">
        <nb-form-field>
          <nb-icon nbPrefix icon="orbi" pack="al"></nb-icon>
          <nb-select
            fullWidth
            formControlName="template_id"
            [status]="showInputError('template_id') ? 'danger' : 'basic'"
            placeholder="{{ 'input.tutorTemplate.placeholder' | translate }}"
          >
            <nb-option
              *ngFor="let t of this.tutorService.tutorTemplates$ | async"
              [value]="t.id"
            >
              {{ "enums.assistantTemplate." + t.name | translate }}
            </nb-option>
          </nb-select>
        </nb-form-field>
      </div>
    </div>

    <!-- Chat-styling: hidden for alpha_dozent bots. The dozent runs only
         as an add-on attached to a tutor and inherits the tutor's chat
         widget styling, so a per-dozent override would never reach a
         learner anyway. -->
    <div *ngIf="!isDozentBot" class="form-group row" alAnchor="agent.widget-style">
      <label for="title" class="label col-sm-3 col-form-label">
        {{ "input.chatStyleSelect.label" | translate }}
        <nb-icon
          icon="question-mark-circle-outline"
          nbPopover="{{ 'popovers.inputChatStyleSelect' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <div class="col-sm-9">
        <nb-form-field>
          <nb-icon nbPrefix icon="color-palette-outline"></nb-icon>
          <nb-select
            fullWidth
            formControlName="widget_setting_id"
            [status]="showInputError('widget_setting_id') ? 'danger' : 'basic'"
            placeholder="{{ 'input.chatStyleSelect.placeholder' | translate }}"
          >
            <nb-option
              *ngFor="let d of chatService.chatSettings$ | async"
              [value]="d.id"
              >{{ d.widget_instance }}</nb-option
            >
            <nb-option [value]="">
              {{ "input.chatStyleSelect.defaultValue" | translate }}</nb-option
            >
          </nb-select>
        </nb-form-field>
      </div>
    </div>

    <!-- Onboarding tour master switch — a template setting
         (onboarding_tour_enabled, migration 104), not a bots column, so it
         saves through its own handler instead of the form's auto-save.
         Hidden for alpha_dozent: the dozent never runs as a standalone
         widget, so there is no tour to configure. -->
    <div *ngIf="!isDozentBot && onboardingSetting" class="form-group row" alAnchor="agent.onboarding-tour">
      <label class="label col-sm-3 col-form-label">
        {{ "input.onboardingTour.label" | translate }}
        <nb-icon
          icon="question-mark-circle-outline"
          nbPopover="{{ 'popovers.inputOnboardingTour' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <div class="col-sm-9">
        <nb-toggle
          [checked]="onboardingTourOn"
          (checkedChange)="onToggleOnboardingTour($event)"
        ></nb-toggle>
      </div>
    </div>

    <!-- Tour scope (onboarding_tour_topics / onboarding_tour_max_autostarts)
         — only while the tour is on. Every topic is listed; only those this
         agent can explain (onboarding-tour-topics.ts) are selectable, the
         others are disabled with the reason and keep their saved state on
         save. -->
    <ng-container *ngIf="!isDozentBot && onboardingSetting && onboardingTourOn">
      <!-- Sub-settings of the switch above: indented label + rail
           (.dependent-group); controls keep the width of every other row. -->
      <div
        *ngIf="
          (onboardingTopicsSetting && availableOnboardingTopics.length) ||
          onboardingMaxAutostartsSetting
        "
        class="dependent-group"
      >
        <div
          *ngIf="onboardingTopicsSetting && availableOnboardingTopics.length"
          class="form-group row"
          alAnchor="agent.onboarding-topics"
        >
          <!-- nb-select is not labelable: the label is tied by id via
               aria-labelledby, not by `for`. -->
          <label id="onboarding-tour-topics-label" class="label col-sm-3 col-form-label">
            {{ "input.onboardingTour.topicsLabel" | translate }}
            <nb-icon
              icon="question-mark-circle-outline"
              nbPopover="{{ 'input.onboardingTour.topicsHint' | translate }}"
              nbPopoverTrigger="hover"
              nbPopoverPlacement="bottom"
            ></nb-icon>
          </label>
          <div class="col-sm-9">
            <nb-select
              id="onboarding-tour-topics"
              aria-labelledby="onboarding-tour-topics-label"
              multiple
              fullWidth
              [formControl]="onboardingTopicsControl"
              placeholder="{{ 'input.onboardingTour.topicsPlaceholder' | translate }}"
            >
              <nb-option
                *ngFor="let topic of allOnboardingTopics"
                [value]="topic"
                [disabled]="!isOnboardingTopicAvailable(topic)"
              >
                {{ "input.onboardingTour.topics." + topic | translate }}
                <span
                  *ngIf="!isOnboardingTopicAvailable(topic)"
                  class="al-option-note"
                >
                  ·
                  {{
                    (topic === "lecturer"
                      ? "input.onboardingTour.unavailableLecturer"
                      : "input.onboardingTour.unavailable"
                    ) | translate
                  }}
                </span>
              </nb-option>
            </nb-select>
          </div>
        </div>

        <div *ngIf="onboardingMaxAutostartsSetting" class="form-group row" alAnchor="agent.onboarding-max">
          <label for="onboarding-tour-max-autostarts" class="label col-sm-3 col-form-label">
            {{ "input.onboardingTour.maxAutostartsLabel" | translate }}
            <nb-icon
              icon="question-mark-circle-outline"
              nbPopover="{{ 'input.onboardingTour.maxAutostartsHint' | translate }}"
              nbPopoverTrigger="hover"
              nbPopoverPlacement="bottom"
            ></nb-icon>
          </label>
          <div class="col-sm-9">
            <nb-form-field>
              <input
                id="onboarding-tour-max-autostarts"
                nbInput
                fullWidth
                type="number"
                step="1"
                [min]="onboardingMaxAutostartsMin"
                [max]="onboardingMaxAutostartsMax"
                [formControl]="onboardingMaxAutostartsControl"
                [status]="
                  onboardingMaxAutostartsControl.touched &&
                  onboardingMaxAutostartsControl.invalid
                    ? 'danger'
                    : 'basic'
                "
                (blur)="onOnboardingMaxAutostartsBlur()"
              />
              <span nbSuffix>{{
                "input.onboardingTour.maxAutostartsSuffix" | translate
              }}</span>
            </nb-form-field>
          </div>
        </div>
      </div>
    </ng-container>

  </div>
</form>
